// @purpose GLUE
// In-page links into a closed <details> (the home's "What brought you here?" router, its chapter list and
// "Next:" links): open the target before the browser jumps to it, and on load when the URL carries its
// #fragment, so a link never lands on a collapsed card. Delegated on document (boosted swaps need nothing).

function openFor(id) {
  if (!id) return;
  const el = document.getElementById(id);
  const box = el && (el.tagName === "DETAILS" ? el : el.closest("details"));
  if (box && !box.open) box.open = true;
}

export function initDisclose() {
  document.addEventListener("click", (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (a) openFor(decodeURIComponent(a.getAttribute("href").slice(1)));
  });
  const open = () => {
    // A page whose sections moved elsewhere lists them as data-anchor-moves='{"id": "/new/#id"}' (e.g. /research/
    // after the evidence atlas moved to /research/evidence/): an old #link forwards instead of landing nowhere.
    const id = decodeURIComponent(location.hash.slice(1));
    const host = id && document.querySelector("[data-anchor-moves]");
    if (host && !document.getElementById(id)) {
      try {
        const to = JSON.parse(host.dataset.anchorMoves || "{}")[id];
        if (to) return location.replace(to);
      } catch {
        /* malformed map: ignore */
      }
    }
    openFor(id);
  };
  open();
  document.addEventListener("htmx:afterSettle", open);
  window.addEventListener("hashchange", open);
}

// Section rails (`[data-px-rail-nav]`, the home's "On this page" strip): mark the link for the section in view.
export function initRails() {
  const rail = document.querySelector("[data-px-rail-nav]");
  if (!rail || !("IntersectionObserver" in window)) return;
  const links = [...rail.querySelectorAll('a[href^="#"]')];
  const byId = new Map(links.map((a) => [a.getAttribute("href").slice(1), a]));
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        for (const a of links) a.removeAttribute("aria-current");
        const a = byId.get(e.target.id);
        if (a) {
          a.setAttribute("aria-current", "true");
          a.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      }
    },
    { rootMargin: "-30% 0px -60% 0px" },
  );
  for (const id of byId.keys()) {
    const el = document.getElementById(id);
    if (el) io.observe(el);
  }
}
